/* @flow */

import { rem } from 'polished';

import { fadeDuration } from '@e180/ui/lib/token/animation';
import { textColor } from '@e180/ui/lib/token/color';
import { antialiasing } from 'src/shared/app/base/style/token/helper';
import { mediumGrey } from '@e180/ui/lib/token/palette';
import { baseFontSize } from '@e180/ui/lib/token/typography';

export default {
  root: {
    extend: antialiasing,

    color: textColor,

    fontSize: rem(15, baseFontSize),
    lineHeight: 18 / 15,
    textDecoration: 'none',

    transition: ['color', fadeDuration],

    '&:hover': {
      color: mediumGrey,
    },
    '&:active': {
      textDecoration: 'underline',
    },
  },
  icon: {
    // Necessary for transformation to work
    display: 'inline-block',

    marginLeft: rem(8, baseFontSize),

    stroke: ({ accentColor }: Object) => accentColor,

    transition: ['transform', '0.2s', 'ease-in-out'],

    '$root:hover &': {
      transform: 'translateX(-3px)',
    },
    '$root:active &': {
      transform: 'translateX(-3px)',
    },
  },
};
